import { ActionType, ICalendarStateAction } from '../../classes/calendar-actions';

import * as moment from 'moment';
import { IPromoCodeState, defaultPromoCodeState, PromoCodeState } from '../../classes/promo-code';

/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function promoCodeReducer(state: IPromoCodeState = defaultPromoCodeState, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.RequestPromoCodeApply: {
            return { ...state, promoCodeRequesting: true } as IPromoCodeState;
        }
        case ActionType.ReceivePromoCodeApply: {
            return { ...state, promoCodeRequesting: false, promoCodeState: PromoCodeState.APPLIED, promoApiResponse: action.value.apiResponse, appliedPromoCode: action.value.promoCode, promoCodeError: null } as IPromoCodeState;
        }
        case ActionType.ErrorPromoCodeApply: {
            return { ...state, promoCodeRequesting: false, promoCodeState: PromoCodeState.FAILURE, promoCodeError: action.value } as IPromoCodeState;
        }
        case ActionType.UpdatePromoCode: {
            return { ...state, promoCodeString: action.value } as IPromoCodeState;
        }
        default:
            return state;
    }
}
